import React from 'react';

//bs
import { Container, Row, Col } from 'reactstrap';

//images
import Cap1Img from 'css/images/bases/cap1.jpg';
import Cap2Img from 'css/images/bases/cap2.jpg';

const LegalTextPage = () => {
	return (
		<div className="legal-texts">
			<Container>
				<Row>
					<Col lg="10" className="mx-auto my-5">
						<h1>BASES LEGALES - MAZDA ACCESSORY CHALLENGE</h1>

						{/* PRIMERA */}
						<h2>PRIMERA.- Empresa responsable y entidad gestora</h2>
						<p>
							1.1. MAZDA AUTOMÓVILES ESPAÑA, S.A., con NIF A-82585290 y
							domicilio en calle Manuel Pombo Angulo, 28, Planta 2, 28050 Madrid
							(en adelante, "MAZDA" o el "Promotor"), organiza la presente
							promoción con carácter exclusivo para los vendedores de su red
							oficial de concesionarios en España.
						</p>
						<p>
							1.2. La gestión operativa, la plataforma web, la secretaría
							técnica y la adquisición y envío de premios son realizadas por
							ACCIONA INGENIERÍA CULTURAL, S.L., con CIF B-82234451 (en
							adelante, "ACCIONA"), actuando como encargada del tratamiento de
							datos personales por cuenta de MAZDA. ACCIONA no asume la
							condición de promotor ni es responsable fiscal de la promoción.
						</p>

						{/* SEGUNDA */}
						<h2>SEGUNDA.- Legitimación para participar</h2>
						<p>
							2.1. Podrán participar en el concurso exclusivamente los asesores
							comerciales certificados de los concesionarios de la red MAZDA en
							España (el/los "Vendedor/es" o "Participantes") que, a la fecha de
							canje del premio, sigan vinculados laboralmente con un
							concesionario Mazda y mantengan vigente la certificación de asesor
							comercial otorgada por MAZDA.
						</p>
						<p>
							2.2. Quedan excluidos de la participación: (i) los empleados y
							colaboradores de MAZDA y de ACCIONA; (ii) los familiares directos
							hasta segundo grado de los anteriores; (iii) cualquier persona que
							no reúna la condición de Vendedor certificado; y (iv) cualquier
							Participante respecto del que se detecten prácticas fraudulentas,
							ventas simuladas, cancelaciones de pedidos, anulaciones de ventas
							o incumplimiento de las presentes Bases.
						</p>

						{/* TERCERA */}
						<h2>TERCERA.- Objeto del concurso</h2>
						<p>
							3.1. Mazda Accessory Challenge es un programa destinado a premiar
							a los mejores vendedores de Accesorios Originales Mazda.
						</p>
						<p>
							3.2. Los vendedores que se apunten al reto sumarán,
							individualmente, puntos al vender ciertos accesorios determinados
							por MAZDA. Los puntos obtenidos podrán ser canjeados por premios,
							si se alcanza el número de puntos establecido por MAZDA para cada
							premio.
						</p>

						{/* CUARTA */}
						<h2>CUARTA.- Forma y periodo de participación</h2>
						<p>
							4.1. Para participar en el concurso, los vendedores deberán darse
							de alta en la web{' '}
							<a
								href="https://www.mazdaaccessorieschallenge.com/"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://www.mazdaaccessorieschallenge.com/
							</a>
							. MAZDA facilitará a cada vendedor, a través del Jefe de Zona de
							MAZDA, un código de usuario y una clave inicial y provisional para
							facilitar el alta en la web de gestión del concurso. Será
							necesario modificar la contraseña inicial en el primer inicio de
							sesión.
						</p>
						<p>
							4.2. La página pedirá ingresar el código de concesión, el nombre y
							apellidos del vendedor, la dirección de correo electrónico -a
							través de la cual se producirán todas las comunicaciones-,
							teléfono corporativo y los demás datos requeridos fiscalmente (en
							especial, DNI, domicilio fiscal) para que MAZDA practique e
							ingrese la retención o ingreso a cuenta del IRPF correspondiente
							al total de premios canjeados por cada ganador durante la duración
							del concurso.
						</p>
						<p>
							4.3. Cada Vendedor es personalmente responsable de la custodia de
							su usuario y contraseña. Queda prohibido compartir, ceder o
							facilitar a terceros las claves de acceso. El acceso o canje
							realizado con las credenciales de un Vendedor se entenderá
							realizado por éste a todos los efectos. MAZDA podrá suspender
							cautelarmente el acceso de cualquier Vendedor en caso de sospecha
							fundada de uso indebido.
						</p>
						<p>
							4.4. Los participantes deberán aceptar las bases y la política de
							privacidad aplicable al concurso, marcando las casillas
							correspondientes en el momento del alta.
						</p>
						<p>
							4.5. El concurso se desarrollará entre el 1 de abril y el 30 de
							junio de 2026, ambos inclusive, ampliándose el periodo de canje de
							puntos hasta el 25 de julio de 2026.
						</p>

						{/* QUINTA */}
						<h2>QUINTA.- Ámbito y naturaleza</h2>
						<p>
							El concurso será de ámbito nacional. Participación gratuita. La
							participación no constituye sorteo ni juego de azar y no está
							sujeta a la normativa de juego; se trata de una promoción cuya
							adjudicación depende exclusivamente del cumplimiento de las reglas
							objetivas establecidas en las presentes Bases.
						</p>

						{/* SEXTA */}
						<h2>SEXTA.- Mecánica del concurso</h2>
						<p>
							6.1. El vendedor marcará en Sigma que el vehículo tiene un Pack de
							Accesorios marcando "Sí" en la casilla correspondiente. Además,
							deberá marcar los accesorios del concurso que lleve el vehículo en
							cuestión. Estos accesorios deberán aparecer en la oferta al
							cliente, así como en el aviso de venta final.
						</p>
						<p>
							6.2. A la hora de pedir los accesorios del concurso por eparts2,
							la referencia de pedido deberá ser el número de oferta al cliente
							o el bastidor del vehículo.
						</p>
						<img src={Cap1Img} alt="Capítulo 6.1" className="my-3" />
						<img src={Cap2Img} alt="Capítulo 6.2" className="my-3" />
						<p>
							6.3. Solo contabilizarán para el concurso los accesorios del CX-5
							(KM) listados en estas Bases.
						</p>
						<p>
							6.4. Los puntos obtenidos por cada vendedor se actualizarán en la
							web cada 15 días aproximadamente a partir de los datos remitidos
							por MAZDA. Cualquier reclamación sobre la asignación de puntos
							deberá dirigirse a MAZDA en los 15 días siguientes a la
							publicación de la actualización; transcurrido dicho plazo, los
							puntos publicados se entenderán firmes.
						</p>
						<p>
							6.5. Los puntos obtenidos podrán acumularse desde el inicio del
							concurso hasta el 30 de junio de 2026 y/o ser canjeados
							parcialmente. El canje total o parcial de puntos deberá realizarse
							desde el 30 de abril hasta el 25 de julio de 2026, ambos
							inclusive.
						</p>
						<p>
							6.6. Si con posterioridad a la asignación de puntos se produce la
							anulación de la venta, el rechazo del vehículo por el cliente, la
							devolución de los accesorios o cualquier otra circunstancia que
							determine que la venta no llegó a consumarse, MAZDA restará los
							puntos correspondientes del saldo del Vendedor. Si los puntos ya
							hubieran sido canjeados por un premio, MAZDA podrá, a su elección:
							(i) compensar con puntos futuros; o (ii) reclamar al Vendedor el
							valor del premio.
						</p>
						<p>
							6.7. Los puntos no canjeados a 25 de julio de 2026 caducarán
							automáticamente, sin generar derecho a compensación alguna. Los
							puntos son meramente una unidad de cuenta interna del Programa, no
							tienen valor económico, no son transmisibles y no pueden ser
							canjeados por metálico.
						</p>

						{/* SÉPTIMA */}
						<h2>SÉPTIMA.- Descripción de los accesorios del concurso</h2>
						<p>
							Los accesorios del CX-5 (KM) que conferirán en el concurso puntos
							a su vendedor, serán los siguientes:
						</p>

						<h3>
							Paquete de Iluminación Exterior.{' '}
							<span className="pack-points">Puntos Pack Completo: 2</span>
						</h3>
						<p>Este pack se compone de:</p>
						<table className="legal-table">
							<thead>
								<tr>
									<th>Accesorio</th>
									<th>Referencia</th>
									<th>Puntos individuales</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Proyector LED de acceso</td>
									<td>KLAN-V4-590</td>
									<td>1</td>
								</tr>
								<tr>
									<td>Proyector para el portón trasero</td>
									<td>KLBC-V3-590</td>
									<td>1</td>
								</tr>
							</tbody>
						</table>

						<h3>
							Paquete Offroad (Versión para gancho de remolque).{' '}
							<span className="pack-points">Puntos Pack Completo: 4</span>
						</h3>
						<p>Este pack se compone de:</p>
						<table className="legal-table">
							<thead>
								<tr>
									<th>Accesorio</th>
									<th>Referencia</th>
									<th>Puntos individuales</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Embellecedor delantero</td>
									<td>KLBC-V3-290</td>
									<td>2</td>
								</tr>
								<tr>
									<td>Embellecedor trasero para CX-5 con gancho de remolque</td>
									<td>KLBC-V3-300-TB</td>
									<td>2</td>
								</tr>
							</tbody>
						</table>

						<h3>
							Paquete Offroad (Versión sin gancho de remolque){' '}
							<span className="pack-points">Puntos Pack Completo: 4</span>
						</h3>
						<p>Este pack se compone de:</p>
						<table className="legal-table">
							<thead>
								<tr>
									<th>Accesorio</th>
									<th>Referencia</th>
									<th>Puntos individuales</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Embellecedor delantero</td>
									<td>KLBC-V3-290</td>
									<td>2</td>
								</tr>
								<tr>
									<td>Embellecedor trasero para CX-5 sin gancho de remolque</td>
									<td>KLBC-V3-300</td>
									<td>2</td>
								</tr>
							</tbody>
						</table>

						<h3>
							Gancho de remolque "Manos libres".{' '}
							<span className="pack-points">Puntos Pack Completo: 6</span>
						</h3>
						<p>Este pack se compone de:</p>
						<table className="legal-table">
							<thead>
								<tr>
									<th>Accesorio</th>
									<th>Referencia</th>
									<th>Puntos individuales</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Gancho de remolque "Manos libres"</td>
									<td>KLBC-V3-920</td>
									<td>6</td>
								</tr>
							</tbody>
						</table>

						<h3>
							Paquete aerodinámico.{' '}
							<span className="pack-points">Puntos Pack Completo: 15</span>
						</h3>
						<p>Este pack se compone de:</p>
						<table className="legal-table">
							<thead>
								<tr>
									<th>Accesorio</th>
									<th>Referencia</th>
									<th>Puntos individuales</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Alerón trasero de techo</td>
									<td>KLBC-V4-920</td>
									<td>4</td>
								</tr>
								<tr>
									<td>Faldón delantero</td>
									<td>KLBC-V4-9A0</td>
									<td>3</td>
								</tr>
								<tr>
									<td>Faldón trasero</td>
									<td>KLBC-V4-9C0</td>
									<td>3</td>
								</tr>
								<tr>
									<td>Juego de faldones laterales</td>
									<td>KLBC-V4-9B0</td>
									<td>5</td>
								</tr>
							</tbody>
						</table>

						<h3>
							Paquete de Iluminación Interior.{' '}
							<span className="pack-points">Puntos Pack Completo: 4</span>
						</h3>
						<p>
							¡Atención! Los acabados HOMURA ya llevan la iluminación interior
							de bienvenida de fábrica.
						</p>
						<p>Este pack se compone de:</p>
						<table className="legal-table">
							<thead>
								<tr>
									<th>Accesorio</th>
									<th>Referencia</th>
									<th>Puntos individuales</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Iluminación interior de bienvenida</td>
									<td>KLBC-V7-050</td>
									<td>1</td>
								</tr>
								<tr>
									<td>Umbrales de puerta iluminados</td>
									<td>KLBK-V1-370</td>
									<td>3</td>
								</tr>
							</tbody>
						</table>

						<h3>
							Pack Thule Portabicicletas+ Baul.{' '}
							<span className="pack-points">Puntos Pack Completo: 14</span>
						</h3>
						<p>Este pack se compone de:</p>
						<table className="legal-table">
							<thead>
								<tr>
									<th>Accesorio</th>
									<th>Referencia</th>
									<th>Puntos individuales</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Portabicicletas para enganche de remolque</td>
									<td>4100-79-621</td>
									<td>6</td>
								</tr>
								<tr>
									<td>Baul para gancho de remolque</td>
									<td>4100-79-630</td>
									<td>8</td>
								</tr>
							</tbody>
						</table>

						{/* OCTAVA */}
						<h2>OCTAVA.- Descripción y entrega de premios</h2>
						<p>
							8.1. El vendedor podrá consultar el detalle y valor de mercado de
							los premios en la sección "Catálogo de Regalos" de la web del
							Programa.
						</p>
						<p>
							8.2. Los premios canjeados se enviarán exclusivamente a la
							dirección del concesionario en el que trabaje el vendedor ganador.
							Se informará al vendedor del envío y de la fecha estimada de la
							entrega a través del correo electrónico del puesto de trabajo del
							vendedor.
						</p>
						<p>
							8.3. El vendedor dispondrá de un plazo de quince (15) días
							naturales, a contar desde la fecha de comunicación del envío o, en
							su caso, de la entrega efectiva, para informar a MAZDA o a ACCIONA
							como entidad gestora de cualquier problema en la entrega.
							Transcurrido ese plazo, el vendedor no podrá reclamar por falta o
							defecto en la entrega de premios.
						</p>
						<p>
							8.4. La adquisición y entrega material de los premios se realiza a
							través de proveedores minoristas terceros (como El Corte Inglés,
							Media Markt, Create y otros). En consecuencia, la fecha estimada
							de entrega dependerá de dichos proveedores y de sus servicios de
							transporte. Ni MAZDA ni ACCIONA responderán de retrasos, roturas,
							extravíos, faltas de stock sobrevenidas o incidencias de entrega
							imputables a dichos terceros, sin perjuicio de que ACCIONA
							gestione diligentemente la incidencia con el proveedor
							correspondiente.
						</p>

						{/* NOVENA */}
						<h2>NOVENA.- Condiciones para la entrega de premios</h2>
						<p>
							9.1. Será condición indispensable para efectuar la entrega del
							premio que el ganador reúna la condición de vendedor. MAZDA no
							entregará premio alguno en el supuesto de que detecte que el
							ganador no tiene la condición de vendedor.
						</p>
						<p>
							9.2. Si por cualquier razón ajena a MAZDA no hubiera
							disponibilidad del regalo previsto, el promotor se reserva el
							derecho de sustituirlo por otro de igual o superior coste.
						</p>
						<p>
							9.3. El premio es intransferible, ni podrá ser canjeado por
							metálico ni por cualquier otro premio.
						</p>
						<p>
							9.4. Queda prohibida la comercialización y/o venta de los premios.
						</p>
						<p>
							9.5. El valor de los premios a efectos fiscales será la suma del
							valor de mercado de todos los premios obtenidos por un mismo
							vendedor y el importe del ingreso a cuenta del IRPF del vendedor
							efectuado por MAZDA ante la AEAT, si el valor de la totalidad de
							los premios obtenidos por un vendedor supera la suma de 300 euros.
							En estos casos, MAZDA enviará al domicilio fiscal del ganador el
							correspondiente certificado de retenciones practicadas. El
							Vendedor es responsable de incorporar en su declaración anual del
							IRPF los premios obtenidos, en los términos legalmente previstos.
						</p>
						<p>
							9.6. MAZDA se reserva el derecho a modificar, suspender
							temporalmente o cancelar anticipadamente el Programa por causas
							justificadas (incluyendo, a título enunciativo, cambios
							normativos, fuerza mayor, detección de fraude generalizado o
							circunstancias empresariales excepcionales), sin que ello genere
							derecho a indemnización para los Participantes, más allá de la
							entrega de los premios ya canjeados y confirmados a la fecha de la
							modificación o cancelación. Cualquier modificación será comunicada
							a los Participantes por la web del Programa y/o correo electrónico
							con antelación razonable.
						</p>

						{/* DÉCIMA */}
						<h2>DÉCIMA.- Limitación de responsabilidad</h2>
						<p>
							10.1. MAZDA no se responsabiliza por el uso del premio que el
							ganador pueda realizar.
						</p>
						<p>
							10.2. MAZDA ni ACCIONA no serán responsables de los servicios que
							terceras empresas deban prestar con motivo de la entrega del
							regalo de la presente promoción.
						</p>
						<p>
							10.3. La garantía de los premios entregados se regirá por los
							términos y condiciones de la garantía otorgada por el fabricante a
							MAZDA como compradora de los premios.
						</p>
						<p>
							10.4. <strong>Fuerza mayor.</strong> Ninguna de las Partes será
							responsable de la imposibilidad de ejecutar en plazo el Programa
							cuando ello se deba a causas de fuerza mayor o caso fortuito,
							incluyendo interrupciones de plataformas tecnológicas,
							ciberataques, problemas de suministro en los proveedores terceros
							de regalos o cualesquiera otras circunstancias ajenas al control
							razonable de MAZDA y ACCIONA.
						</p>
						<p>
							10.5.{' '}
							<strong>Exoneración de ACCIONA frente a Participantes.</strong>{' '}
							Los Participantes reconocen que el único Promotor del concurso es
							MAZDA y que ACCIONA actúa como mera entidad gestora. Las
							reclamaciones relativas a la asignación de puntos, validez de la
							venta, condición de Vendedor certificado o cumplimiento fiscal se
							dirigirán exclusivamente a MAZDA. Las reclamaciones relativas a la
							operativa de la plataforma o al envío del premio se podrán dirigir
							a ACCIONA como entidad gestora.
						</p>

						{/* UNDÉCIMA */}
						<h2>UNDÉCIMA.- Política de privacidad</h2>
						<p>
							11.1. Al participar en el concurso aceptas el tratamiento de tus
							datos por Mazda Automóviles España S.A. como Responsable del
							Tratamiento con el fin de gestionar el concurso y de practicar la
							retención fiscal que corresponda aplicar al total de los premios
							canjeados por cada vendedor. También podrán ser tratados por el
							concesionario en el que trabajas con el fin de que éste proceda a
							la entrega de premios, y por ACCIONA INGENIERÍA CULTURAL, S.L.
							como Encargada del Tratamiento, para la ejecución material del
							Programa (alta en la plataforma, gestión de puntos, canje y envío
							de premios, comunicaciones operativas y elaboración de los
							listados fiscales).
						</p>
						<p>
							11.2. Base legitimadora: ejecución de la relación derivada de la
							participación voluntaria en el concurso y cumplimiento de
							obligaciones legales (fiscales) de MAZDA. Plazo de conservación:
							durante la vigencia del Programa y, posteriormente, bloqueados
							durante los plazos legales de prescripción (en particular, 4 años
							a efectos fiscales). Destinatarios: AEAT y otros organismos
							públicos cuando resulte obligatorio, así como proveedores terceros
							necesarios para la entrega de premios, en el marco de los acuerdos
							de tratamiento aplicables.
						</p>
						<p>
							11.3. Derechos: Los participantes podrán ejercer los derechos de
							acceso, rectificación, supresión, oposición, limitación del
							tratamiento, portabilidad y cualquier otro derecho que
							corresponda, por correo postal (Mazda Automóviles España, C/Manuel
							Pombo Angulo 28, 2ª planta – 28050 Madrid) o email (
							<a href="mailto:privacidad@mazdaeur.com">
								privacidad@mazdaeur.com
							</a>
							), así como reclamar ante la Agencia Española de Protección de
							Datos (
							<a
								href="https://www.aepd.es"
								target="_blank"
								rel="noopener noreferrer"
							>
								www.aepd.es
							</a>
							). Más información en:{' '}
							<a
								href="https://www.mazda.es/privacidad/"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://www.mazda.es/privacidad/
							</a>
							.
						</p>

						{/* DUODÉCIMA */}
						<h2>
							DUODÉCIMA.- Legislación aplicable, aceptación de las bases y
							competencia
						</h2>
						<p>
							La presente promoción se regirá por la legislación española
							vigente. La participación en el concurso supone la aceptación
							íntegra de las presentes Bases y de la Política de Privacidad del
							Programa. Todos los conflictos que se susciten en aplicación de
							las presentes Bases se resolverán por los Juzgados y Tribunales
							que correspondan según Ley.
						</p>

						<hr />

						<h1>
							<strong>ADDENDA N&ordm; 1&nbsp;</strong>
							<strong>A LAS BASES LEGALES&nbsp;</strong>
							<strong>Mazda Accessory Challenge 2026</strong>
						</h1>
						<h2>1. Identificaci&oacute;n</h2>
						<p>
							<strong>MAZDA AUTOM&Oacute;VILES ESPA&Ntilde;A, S.A.</strong> (en
							adelante, &laquo;<strong>MAZDA</strong>&raquo; o el &laquo;
							<strong>Promotor</strong>&raquo;), en virtud de la facultad de
							modificaci&oacute;n prevista en la cl&aacute;usula 9.6 de las
							Bases Legales del concurso &laquo;
							<strong>Mazda Accessory Challenge</strong>&raquo; (en adelante,
							las &laquo;<strong>Bases</strong>&raquo;), publicadas en la web
							https://www.mazdaaccessorieschallenge.com/ e &iacute;ntegramente
							aceptadas por los Participantes al darse de alta en la plataforma,
							procede a modificar las Bases en los t&eacute;rminos que se
							indican a continuaci&oacute;n.
						</p>
						<p>
							La presente Addenda entrar&aacute; en vigor en la fecha de su
							publicaci&oacute;n en la web del Programa y ser&aacute; comunicada
							a todos los Participantes registrados mediante correo
							electr&oacute;nico a la direcci&oacute;n corporativa facilitada en
							el momento del alta.
						</p>
						<p>
							Las cl&aacute;usulas de las Bases no expresamente modificadas por
							esta Addenda mantienen su vigencia y eficacia &iacute;ntegras.
						</p>
						<h2>2. Modificaciones</h2>
						<h6>
							2.1. Cl&aacute;usula Cuarta (Forma y periodo de
							participaci&oacute;n)
						</h6>
						<p>Donde dice:</p>
						<table cellspacing="0" cellpadding="0">
							<tbody>
								<tr>
									<td
										valign="top"
										style={{ backgroundColor: 'rgba(249, 198, 193, 0.46)' }}
									>
										<p>
											&laquo;El concurso se desarrollar&aacute; entre el 15 de
											abril y el 30 de junio de 2026, ambos inclusive,
											ampli&aacute;ndose el periodo de canje de puntos hasta el
											31 de julio de 2026.&raquo;
										</p>
									</td>
								</tr>
							</tbody>
						</table>
						<p>Debe decir:</p>
						<table cellspacing="0" cellpadding="0">
							<tbody>
								<tr>
									<td
										valign="top"
										style={{ backgroundColor: 'rgba(97, 189, 109, 0.20)' }}
									>
										<p>
											&laquo;El concurso se desarrollar&aacute; entre el 15 de
											abril y el 31 de diciembre de 2026, ambos inclusive,
											ampli&aacute;ndose el periodo de canje de puntos hasta el
											25 de enero de 2027.&raquo;
										</p>
									</td>
								</tr>
							</tbody>
						</table>
						<h6>2.2. Cl&aacute;usula Sexta, apartado 6.5 (Periodo de canje)</h6>
						<p>Donde dice:</p>
						<table cellspacing="0" cellpadding="0">
							<tbody>
								<tr>
									<td
										valign="top"
										style={{ backgroundColor: 'rgba(249, 198, 193, 0.46)' }}
									>
										<p>
											&laquo;Los puntos obtenidos podr&aacute;n acumularse desde
											el inicio del concurso hasta el 30 de junio de 2026 y/o
											ser canjeados parcialmente. El canje total o parcial de
											puntos deber&aacute; realizarse desde el 30 de abril hasta
											el 31 de julio de 2026, ambos inclusive.&raquo;
										</p>
									</td>
								</tr>
							</tbody>
						</table>
						<p>Debe decir:</p>
						<table cellspacing="0" cellpadding="0">
							<tbody>
								<tr>
									<td
										valign="top"
										style={{ backgroundColor: 'rgba(97, 189, 109, 0.20)' }}
									>
										<p>
											&laquo;Los puntos obtenidos podr&aacute;n acumularse desde
											el inicio del concurso hasta el 25 de enero de 2027 y/o
											ser canjeados parcialmente. El canje total o parcial de
											puntos deber&aacute; realizarse desde el 30 de abril hasta
											el 25 de enero de 2027, ambos inclusive.&raquo;
										</p>
									</td>
								</tr>
							</tbody>
						</table>
						<h6>
							2.3. Cl&aacute;usula Sexta, apartado 6.7 (Puntos no canjeados)
						</h6>
						<p>Donde dice:</p>
						<table cellspacing="0" cellpadding="0">
							<tbody>
								<tr>
									<td
										valign="top"
										style={{ backgroundColor: 'rgba(249, 198, 193, 0.46)' }}
									>
										<p>
											&laquo;Los puntos no canjeados a 31 de julio de 2026
											caducar&aacute;n autom&aacute;ticamente [...]&raquo;
										</p>
									</td>
								</tr>
							</tbody>
						</table>
						<p>Debe decir:</p>
						<table cellspacing="0" cellpadding="0">
							<tbody>
								<tr>
									<td
										valign="top"
										style={{ backgroundColor: 'rgba(97, 189, 109, 0.20)' }}
									>
										<p>
											&laquo;Los puntos no canjeados a 25 de enero de 2027
											caducar&aacute;n autom&aacute;ticamente, sin generar
											derecho a compensaci&oacute;n alguna. Los puntos son
											meramente una unidad de cuenta interna del Programa, no
											tienen valor econ&oacute;mico, no son transmisibles y no
											pueden ser canjeados por met&aacute;lico.&raquo;
										</p>
									</td>
								</tr>
							</tbody>
						</table>
						<h2>3. Comunicaci&oacute;n a los Participantes</h2>
						<p>
							De conformidad con la cl&aacute;usula 9.6 de las Bases, la
							presente Addenda ser&aacute; comunicada a los Participantes por
							los siguientes medios:
						</p>
						<ul>
							<li>
								Publicaci&oacute;n en la web del Programa
								(https://www.mazdaaccessorieschallenge.com/).
							</li>
							<li>
								Env&iacute;o de correo electr&oacute;nico informativo a la
								direcci&oacute;n corporativa de cada Participante registrado.
							</li>
						</ul>
						<p>
							La ampliaci&oacute;n de plazos beneficia a todos los Participantes
							al concederles un periodo adicional para acumular puntos y canjear
							premios, sin alterar las condiciones de participaci&oacute;n, los
							accesorios puntuables ni el cat&aacute;logo de regalos. No es
							necesaria la aceptaci&oacute;n expresa de la modificaci&oacute;n
							por parte de los Participantes.
						</p>
						<h2>4. Vigencia e integridad</h2>
						<p>
							La presente Addenda entrar&aacute; en vigor en la fecha de su
							publicaci&oacute;n en la web del Programa.
						</p>
						<p>
							Las disposiciones de las Bases Legales no expresamente modificadas
							por la presente Addenda conservan su plena vigencia y eficacia.
						</p>
						<p>
							En caso de discrepancia entre las Bases originales y la presente
							Addenda, prevalecer&aacute; lo dispuesto en esta Addenda.
						</p>
						<h2>5. Firma</h2>
						<p>En Madrid, a 30 de Julio de 2026.</p>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default LegalTextPage;
